import { Action } from '@ngrx/store';
import { FeatureFlags } from '../models/feature-flags.model';

export enum FeatureFlagsActionTypes {
	LoadFeatureFlags = '[Feature Flags] Load Feature Flags',
	LoadFeatureFlagsSuccess = '[Feature Flags] Load Feature Flags Success',
	LoadFeatureFlagsFailure = '[Feature Flags] Load Feature Flags Failure',
	SetFeatureFlags = '[Feature Flags] Set Feature Flags'
}

export class LoadFeatureFlagsAction implements Action {
	readonly type = FeatureFlagsActionTypes.LoadFeatureFlags;
}

export class LoadFeatureFlagsSuccessAction implements Action {
	readonly type = FeatureFlagsActionTypes.LoadFeatureFlagsSuccess;
	constructor(public payload: FeatureFlags) {}
}

export class LoadFeatureFlagsFailureAction implements Action {
	readonly type = FeatureFlagsActionTypes.LoadFeatureFlagsFailure;
	constructor(public payload: string) {}
}

export class SetFeatureFlagsAction implements Action {
	readonly type = FeatureFlagsActionTypes.SetFeatureFlags;
	constructor(public payload: FeatureFlags) {}
}

export type FeatureFlagsActions =
	| LoadFeatureFlagsAction
	| LoadFeatureFlagsSuccessAction
	| LoadFeatureFlagsFailureAction
	| SetFeatureFlagsAction;
